import { render, staticRenderFns } from "./product-support.vue?vue&type=template&id=07d02195&scoped=true&"
import script from "./product-support.vue?vue&type=script&lang=js&"
export * from "./product-support.vue?vue&type=script&lang=js&"
import style0 from "./product-support.vue?vue&type=style&index=0&id=07d02195&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d02195",
  null
  
)

export default component.exports